"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding-top: 0px;\n  display: flex;\n  align-items: center;\n  color: #fff;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  max-width: 800px;\n\n  @media (max-width: 640px) {\n    padding: 0 15px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  background: rgb(34, 15, 37);\n  height: 75vh;\n  min-height: 600px;\n  width: 100%;\n  margin: 0 0 120px;\n  padding: 0;\n  background-size: cover;\n  background-position: center center;\n  z-index: -100;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var heroClass = (0, _emotion.css)(_templateObject());
var containerClass = (0, _emotion.css)(_templateObject2());
var contentClass = (0, _emotion.css)(_templateObject3());

var DefaultChildren = function DefaultChildren() {
  return _react["default"].createElement("h1", null, "Data for the people,", _react["default"].createElement("br", null), "by the people.");
};

var Hero = function Hero(_ref) {
  var children = _ref.children,
      mainProjectColor = _ref.mainProjectColor;
  return _react["default"].createElement("div", {
    className: heroClass,
    style: {
      backgroundColor: mainProjectColor
    }
  }, _react["default"].createElement("div", {
    className: containerClass
  }, _react["default"].createElement("div", {
    className: contentClass
  }, children || _react["default"].createElement(DefaultChildren, null))));
};

Hero.displayName = "Hero";
Hero.propTypes = {
  mainProjectColor: _propTypes["default"].string,
  children: _propTypes["default"].node
};
var _default = Hero;
exports["default"] = _default;